<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'GIS_SETTINGS' }]"
></breadcrumbs>

<page-header title="GIS_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="GIS_SERVER_URL">{{
        'GIS_SERVER_URL' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="GIS_GEOSERVER_URL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['GIS_GEOSERVER_URL'])"
          [ngClass]="{ 'is-danger': hasError('GIS_GEOSERVER_URL') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('GIS_GEOSERVER_URL')">
        {{ getError('GIS_GEOSERVER_URL') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="GIS_WORKSPACE">{{
        'GIS_WORKSPACE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="GIS_GEOSERVER_WORKSPACE"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['GIS_GEOSERVER_WORKSPACE'])"
          [ngClass]="{ 'is-danger': hasError('GIS_GEOSERVER_WORKSPACE') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('GIS_GEOSERVER_WORKSPACE')">
        {{ getError('GIS_GEOSERVER_WORKSPACE') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="GIS_EXTENT">{{
        'GIS_EXTENT' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="GIS_MAP_EXTENT"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['GIS_MAP_EXTENT'])"
          [ngClass]="{ 'is-danger': hasError('GIS_MAP_EXTENT') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('GIS_MAP_EXTENT')">
        {{ getError('GIS_MAP_EXTENT') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="GIS_BASE_LAYER">{{
        'GIS_BASE_LAYER' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="GIS_BASE_LAYER"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['GIS_BASE_LAYER'])"
          [ngClass]="{ 'is-danger': hasError('GIS_BASE_LAYER') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('GIS_BASE_LAYER')">
        {{ getError('GIS_BASE_LAYER') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
